/**
 * Time-based quantity fields handler
 * 
 * This script handles the functionality for the time-based quantity fields,
 * automatically updating the main quantity field with the sum of all time fields.
 */

class TimeQuantityFields {
  constructor() {
    this.initTimeQuantityFields();
  }

  initTimeQuantityFields() {
    // Find all time quantity inputs
    const timeInputs = document.querySelectorAll('[data-qty-input]');
    if (!timeInputs.length) return;
    
    // Check if we have recommended usage data and populate fields
    this.populateRecommendedUsage();

    // Set up event listeners for all time quantity inputs
    timeInputs.forEach(input => {
      input.addEventListener('change', () => this.updateTotalQuantity());
      
      // Make sure value is not negative
      input.addEventListener('blur', () => {
        if (parseInt(input.value) < 0 || isNaN(parseInt(input.value))) {
          input.value = 0;
          this.updateTotalQuantity();
        }
      });
    });

    // Set up event listeners for quantity buttons
    const quantityButtons = document.querySelectorAll('.time-qty-button');
    quantityButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const targetId = button.getAttribute('data-target');
        const input = document.getElementById(targetId);
        const isPlus = button.name.includes('plus');
        
        let currentValue = parseInt(input.value) || 0;
        if (isPlus) {
          currentValue++;
        } else if (currentValue > 0) {
          currentValue--;
        }
        
        input.value = currentValue;
        this.updateTotalQuantity();
      });
    });

    // Add form submission validation for non-external products
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (productForm) {
      productForm.addEventListener('submit', (e) => {
        // Check if this is a non-external product with time quantities
        const isNonExternal = document.querySelector('.time-of-day-quantities');
        if (isNonExternal) {
          const totalQty = parseInt(document.querySelector('input[name="quantity"]').value) || 0;
          if (totalQty <= 0) {
            e.preventDefault();
            // Show error message
            const errorWrapper = document.querySelector('.product-form__error-message-wrapper');
            const errorMessage = document.querySelector('.product-form__error-message');
            if (errorWrapper && errorMessage) {
              errorMessage.textContent = 'Please specify at least one dosage time and quantity.';
              errorWrapper.removeAttribute('hidden');
              // Scroll to error message
              errorWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return false;
          } else {
            // Hide error message if it was previously shown
            const errorWrapper = document.querySelector('.product-form__error-message-wrapper');
            if (errorWrapper && !errorWrapper.hasAttribute('hidden')) {
              errorWrapper.setAttribute('hidden', '');
            }
          }
        }
      });
    }

    // Initialize total quantity
    this.updateTotalQuantity();
  }
  
  populateRecommendedUsage() {
    // Check if we have a time-of-day-quantities container with recommended usage
    const container = document.querySelector('.time-of-day-quantities[data-recommended-usage]');
    if (!container) return;
    
    try {
      // Parse the recommended usage JSON
      const recommendedUsage = JSON.parse(container.getAttribute('data-recommended-usage'));
      if (!recommendedUsage) return;
      
      // Get the section ID
      const productForm = document.querySelector('product-form[data-section-id]');
      const sectionId = productForm ? productForm.getAttribute('data-section-id') : '';
      
      // Set values for each time period if available
      if (recommendedUsage.morning !== undefined) {
        const morningInput = document.getElementById('Morning-' + sectionId);
        if (morningInput) morningInput.value = recommendedUsage.morning;
      }
      
      if (recommendedUsage.afternoon !== undefined) {
        const afternoonInput = document.getElementById('Afternoon-' + sectionId);
        if (afternoonInput) afternoonInput.value = recommendedUsage.afternoon;
      }
      
      if (recommendedUsage.evening !== undefined) {
        const eveningInput = document.getElementById('Evening-' + sectionId);
        if (eveningInput) eveningInput.value = recommendedUsage.evening;
      }
      
      if (recommendedUsage.sleep !== undefined) {
        const sleepInput = document.getElementById('Sleep-' + sectionId);
        if (sleepInput) sleepInput.value = recommendedUsage.sleep;
      }
      
      // Update the total quantity
      this.updateTotalQuantity();
    } catch (error) {
      console.error('Error parsing recommended usage:', error);
    }
  }

  updateTotalQuantity() {
    const timeInputs = document.querySelectorAll('[data-qty-input]');
    const mainQuantityInput = document.querySelector('input[name="quantity"]');
    
    if (!timeInputs.length || !mainQuantityInput) return;
    
    // Calculate sum of all time quantity inputs
    let totalQuantity = 0;
    timeInputs.forEach(input => {
      const value = parseInt(input.value) || 0;
      totalQuantity += value;
    });
    
    // Update the main quantity input
    mainQuantityInput.value = totalQuantity;
    
    // Enable/disable add to cart button based on total quantity
    const submitButton = document.querySelector('[data-time-quantity-button]');
    if (submitButton && !submitButton.hasAttribute('disabled')) {
      if (totalQuantity <= 0) {
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('button--disabled');
      } else {
        submitButton.removeAttribute('aria-disabled');
        submitButton.classList.remove('button--disabled');
      }
    }
  }
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', () => {
  new TimeQuantityFields();
});

// Also initialize when the document section is updated (for AJAX cart and theme sections)
document.addEventListener('shopify:section:load', () => {
  new TimeQuantityFields();
});

// Reinitialize when a variant is changed
document.addEventListener('variant:change', () => {
  new TimeQuantityFields();
});
